module.exports = __webpack_public_path__ + "static/media/RollCall_Product_Mockup.712ddbad.png";